import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import store from "./store";
import router from "./router";
import Tabs from "vue-tabs-component";
import "vue-tabs-component/docs/resources/tabs-component.css";
import axios from "axios";
import VueAxios from "vue-axios";
import "@fontsource/ballet";
import "@fontsource/source-sans-pro";
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

// vee password
import VeeValidate from "vee-validate";

Vue.use(VeeValidate);

import "@/assets/css/tailwind.css";
import ProgressBar from "vuejs-progress-bar";
import VueScrollTo from "vue-scrollto";

Vue.use(ProgressBar);

Vue.config.productionTip = false;

Vue.use(VueScrollTo, {
  offset: -100,
});

Vue.use(Tabs);

// Configure Toast with options
Vue.use(Toast, {
  // Example options
  position: "top-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false
});

function resolveApiBaseUrl() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "moldex.rennai.app" || host === "www.moldex.rennai.app") {
      return "https://moldex.api.rennai.app";
    }
    if (
      host === "moldexrealty-buyersportal.com" ||
      host === "www.moldexrealty-buyersportal.com"
    ) {
      return "https://api.moldexrealty-buyersportal.com";
    }
  }
  return process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER_URL
    : process.env.VUE_APP_PROD_SERVER_URL;
}

axios.defaults.baseURL = resolveApiBaseUrl();
Vue.use(VueAxios, axios);

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
